import React from 'react';
import '../styles/HowItWorks.css';

const HowItWorks = () => {
  return (
    <div className="container">
      <div className="how-it-works" id="how">
        <h2 className="how-title">How It <span>Works</span></h2>
        
        <div className="steps-container">
          <div className="step-card">
            <div className="step-number">1</div>
            <div className="step-icon">
              <i className="fas fa-magnifying-glass-location"></i>
            </div>
            <h3>Search</h3>
            <p>Find your perfect ground by location, sport, and availability</p>
            <ul className="step-features">
              <li><i className="fas fa-check-circle"></i> 200+ venues</li>
              <li><i className="fas fa-check-circle"></i> Real-time availability</li>
              <li><i className="fas fa-check-circle"></i> Filter by sport</li>
            </ul>
          </div>
          
          <div className="step-card">
            <div className="step-number">2</div>
            <div className="step-icon">
              <i className="fas fa-calendar-check"></i>
            </div>
            <h3>Pick</h3>
            <p>Select your date, time, and duration that works best for you</p>
            <ul className="step-features">
              <li><i className="fas fa-check-circle"></i> Flexible timing</li>
              <li><i className="fas fa-check-circle"></i> 1-6 hour slots</li>
              <li><i className="fas fa-check-circle"></i> Instant pricing</li>
            </ul>
          </div>
          
          <div className="step-card">
            <div className="step-number">3</div>
            <div className="step-icon">
              <i className="fas fa-circle-check"></i>
            </div>
            <h3>Confirm</h3>
            <p>Book instantly and get confirmation within 30 minutes</p>
            <ul className="step-features">
              <li><i className="fas fa-check-circle"></i> 20% off first booking</li>
              <li><i className="fas fa-check-circle"></i> Secure payment</li>
              <li><i className="fas fa-check-circle"></i> 24/7 support</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;